import Oidc from 'oidc-client';

const mgr = new Oidc.UserManager();

const PopUpPage = () => mgr.signinPopupCallback();

export default PopUpPage;
